import { render } from "./SidebarButton.vue?vue&type=template&id=617392b6&scoped=true"
import script from "./SidebarButton.vue?vue&type=script&lang=js"
export * from "./SidebarButton.vue?vue&type=script&lang=js"

import "./SidebarButton.vue?vue&type=style&index=0&id=617392b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617392b6"]])

export default __exports__